function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import ButtonLike from '../ButtonLike';
import Icon from '../Icon';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The Pill component can represent selected items such as tags
 *
 * ## Composed of
 * - [Icon](../Icon/README.md)
 * - [ButtonLike](.../ButtonLike/README.md)
 *
 * ## Related Components
 * - [Button](../Button/README.md)
 * - [DropdownMenu](../DropdownMenu/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <Pill
 *   onClick={() => console.log('pill clicked')}
 *   label="my pill"
 * />
 *```
 *
 * ## Props
 */

var Pill = function Pill(props) {
  var qa = props.qa,
      onClick = props.onClick,
      className = props.className,
      variant = props.variant,
      name = props.name,
      value = props.value,
      children = props.children;

  var _Pill$getClassName = Pill.getClassName({
    variant: variant,
    className: className
  }),
      root = _Pill$getClassName.root;

  return /*#__PURE__*/React.createElement(ButtonLike, {
    qa: qa,
    variant: "content",
    ctaType: "primary",
    name: name,
    value: value,
    className: root,
    onClick: onClick
  }, children, /*#__PURE__*/React.createElement(Icon, {
    type: "close",
    size: "xs"
  }));
};

Pill.getClassName = function (_ref) {
  var variant = _ref.variant,
      className = _ref.className;
  return {
    root: cx('psw-pill', 'psw-l-line-left', 'psw-l-space-x-xs', _defineProperty({}, "psw-".concat(variant, "-pill"), !!variant), className)
  };
};

Pill.useClassNames = function (classNames) {
  Pill.classNames = classNames;
};

Pill.defaultProps = {
  qa: '',
  className: '',
  variant: '',
  name: '',
  value: '',
  onClick: function onClick() {},
  children: null
};
Pill.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The presentational variant
   */
  variant: PropTypes.string,

  /**
   * What the pill represents, to be sent when clicked
   */
  name: PropTypes.string,

  /**
   * The value associated with the Pill, to be sent when clicked
   */
  value: PropTypes.string,

  /**
   * event callback to call when user clicks
   */
  onClick: PropTypes.func,

  /**
   * The text label to display
   */
  children: PropTypes.node
};
cx = classNamesFor(Pill);
export default Pill;